var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoS360(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 32,
    viewBox: "0 0 160 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5885_12225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6643 21.4559L41.734 19.8406C42.6602 21.3277 43.9103 22.1256 45.5039 22.1256C47.2497 22.1256 48.3498 21.0059 48.3498 19.6036C48.3498 17.9883 46.6258 17.4708 44.8147 16.8882C42.682 16.199 40.3752 15.338 40.3752 12.4487C40.3752 10.0572 42.508 8.15918 45.417 8.15918C47.8085 8.15918 49.2955 9.08534 50.5022 10.4855L48.5846 11.9073C47.8737 10.8094 46.8171 10.2267 45.417 10.2267C43.8233 10.2267 42.7885 11.1746 42.7885 12.403C42.7885 13.9118 44.4473 14.4075 46.2583 15.0098C48.4129 15.7424 50.7631 16.6686 50.7631 19.5993C50.7631 22.0125 48.7803 24.3192 45.5257 24.3192C42.832 24.3192 41.0014 23.1778 39.6643 21.4538V21.4559Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3425 16.2403C66.3425 11.779 69.9407 8.15918 74.4019 8.15918C78.8631 8.15918 82.483 11.779 82.483 16.2403C82.483 20.7015 78.8849 24.3214 74.4019 24.3214C69.9189 24.3214 66.3425 20.7015 66.3425 16.2403ZM80.135 16.2403C80.135 13.0509 77.6348 10.4224 74.4019 10.4224C71.169 10.4224 68.6906 13.0509 68.6906 16.2403C68.6906 19.4297 71.1908 22.0364 74.4019 22.0364C77.613 22.0364 80.135 19.4297 80.135 16.2403Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1682 8.37451H91.0599C94.3993 8.37451 96.6191 10.6377 96.6191 13.5032C96.6191 15.5947 95.4559 17.5753 93.2144 18.2666L96.9647 24.1063H94.271L89.5293 16.6078H90.799C93.1492 16.6078 94.2689 14.949 94.2689 13.5054C94.2689 11.7378 93.1275 10.553 90.8208 10.553H88.514V24.1084H86.166V8.37451H86.1682Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.448 8.37451H103.776L109.12 15.7664L114.636 8.37451H116.856V24.1063H114.527V12.1248L109.074 19.4733L103.794 12.2966V24.1063H101.446V8.37451H101.448Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.889 21.6929L122.85 20.2058C123.754 21.5429 124.919 22.1886 126.535 22.1886C128.387 22.1886 129.659 21.1103 129.659 19.5819C129.659 18.0535 128.452 17.1034 126.578 17.1034H124.767V14.9271H126.557C128.409 14.9271 129.422 13.8923 129.422 12.5139C129.422 11.2203 128.365 10.2072 126.513 10.2072C124.961 10.2072 123.798 10.8746 123.108 12.0595L121.126 10.9181C122.182 9.19405 124.143 8.15918 126.535 8.15918C129.681 8.15918 131.707 9.92672 131.707 12.4487C131.707 14.0423 130.953 15.2489 129.681 15.962C131.103 16.6512 131.985 17.8578 131.985 19.6254C131.985 22.2973 129.959 24.3236 126.533 24.3236C123.926 24.3236 122.243 23.4626 120.886 21.6951L120.889 21.6929Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.837 18.9776C134.837 17.5775 135.29 16.2404 136.001 15.2055L140.353 8.37451H143.134L139.62 13.7837C139.988 13.6967 140.375 13.6315 140.762 13.6315C143.608 13.6315 145.847 15.873 145.847 18.9754C145.847 22.0778 143.455 24.3193 140.351 24.3193C137.246 24.3193 134.835 21.9496 134.835 18.9754L134.837 18.9776ZM143.542 18.9341C143.542 17.1448 142.077 15.6795 140.31 15.6795C138.542 15.6795 137.12 17.1448 137.12 18.9341C137.12 20.7234 138.542 22.1887 140.31 22.1887C142.077 22.1887 143.542 20.7234 143.542 18.9341Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.941 19.2579V13.3531C148.941 10.3789 151.03 8.15918 154.113 8.15918C157.196 8.15918 159.307 10.4442 159.307 13.3314V19.2579C159.307 22.3386 157.389 24.3214 154.113 24.3214C150.837 24.3214 148.941 22.2734 148.941 19.2579ZM156.957 19.1927V13.3966C156.957 11.5442 155.965 10.4007 154.133 10.4007C152.3 10.4007 151.267 11.6508 151.267 13.3966V19.171C151.267 20.9168 152.215 22.0582 154.091 22.0582C155.968 22.0582 156.957 20.8733 156.957 19.1905V19.1927Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5071 10.5725H53.0459V8.37451H64.2947V10.5725H59.8334V24.1063H57.505V10.5725H57.5071Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.2404L3.68727 23.1692V9.31152L0 16.2404Z",
    fill: "#FF5000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7404 31.9807L22.6692 28.2935H8.81152L15.7404 31.9807Z",
    fill: "#FF5000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4831 16.2404L27.7937 9.31152V23.1692L31.4831 16.2404Z",
    fill: "#FF5000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7425 0.5L8.81152 4.18727H22.6714L15.7425 0.5Z",
    fill: "#FF5000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.983 1.91113L9.21606 12.9142V19.9953H13.9904V25.2L21.928 16.3493H17.2211L29.983 1.91113Z",
    fill: "#FF5000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5885_12225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 159.305,
    height: 31.4809,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoS360);
export default __webpack_public_path__ + "static/media/logoS360.e641b611dfeceb0d2a3851293d49af65.svg";
export { ForwardRef as ReactComponent };